import React, { useState } from 'react';
import { Col, Row, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FiFolder } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import TabContent from './TabContent';
import './OrderTabs.css';

const menuItems = [
  {
    name: 'Site Images',
    eventKey: 'site-images',
    icon: FiFolder,
    availableSubFolders: [
      'Site Measurement', 'Design Discussion Brief', '1st cut Meeting',
      '2nd Cut Meeting', '3D Model', 'Material Selection', 'Quotation',
      'Cost Comparison', '40% payment collection', 'Render 3D',
      '2D Validation', 'Site Validation', 'Production Drawing', 'Quality Check',
    ],
  },
  {
    name: 'MOM',
    eventKey: 'mom',
    icon: FiFolder,
    availableSubFolders: [
      'Site Measurement', 'Design Discussion Brief', '1st cut Meeting',
      '2nd Cut Meeting', '3D Model', 'Material Selection', 'Quotation',
      'Cost Comparison', '40% payment collection', 'Render 3D',
      '2D Validation', 'Site Validation', 'Production Drawing', 'Quality Check',
    ],
  },
  {
    name: '2D Layouts',
    eventKey: '2d-layouts',
    icon: FiFolder,
    availableSubFolders: [
      'Site Measurement', 'Design Discussion Brief', '1st cut Meeting',
      '2nd Cut Meeting', '3D Model', 'Material Selection', 'Quotation',
      'Cost Comparison', '40% payment collection', 'Render 3D',
      '2D Validation', 'Site Validation', 'Production Drawing', 'Quality Check',
    ],
  },
  {
    name: 'Presentation & Renders',
    eventKey: 'presentation-renders',
    icon: FiFolder,
    availableSubFolders: [
      'Site Measurement', 'Design Discussion Brief', '1st cut Meeting',
      '2nd Cut Meeting', '3D Model', 'Material Selection', 'Quotation',
      'Cost Comparison', '40% payment collection', 'Render 3D',
      '2D Validation', 'Site Validation', 'Production Drawing', 'Quality Check',
    ],
  },
  {
    name: 'Quotes',
    eventKey: 'quotes',
    icon: FiFolder,
    availableSubFolders: [
      'Site Measurement', 'Design Discussion Brief', '1st cut Meeting',
      '2nd Cut Meeting', '3D Model', 'Material Selection', 'Quotation',
      'Cost Comparison', '40% payment collection', 'Render 3D',
      '2D Validation', 'Site Validation', 'Production Drawing', 'Quality Check',
    ],
  },
  {
    name: 'Finance Docs',
    eventKey: 'finance-docs',
    icon: FiFolder,
    availableSubFolders: [
      'Site Measurement', 'Design Discussion Brief', '1st cut Meeting',
      '2nd Cut Meeting', '3D Model', 'Material Selection', 'Quotation',
      'Cost Comparison', '40% payment collection', 'Render 3D',
      '2D Validation', 'Site Validation', 'Production Drawing', 'Quality Check',
    ],
  },
];

function LeadDocuments() {
  // Default to first folder so something is always visible
  const [activeTab, setActiveTab] = useState(menuItems[0].eventKey);
  const { leadId } = useParams();

  return (
    <Tab.Container activeKey={activeTab}>
      <Row style={{ minHeight: '68vh' }}>

        {/* ── Left sidebar — always visible folders ───────────────────────── */}
        <Col
          sm={2}
          style={{
            borderRight: '1px solid #e9ecef',
            paddingRight: 0,
            backgroundColor: '#fff',
            borderRadius: '7px',
          }}
        >
          <div style={{ padding: '12px 8px 8px 8px' }}>
            <p style={{
              fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8',
              letterSpacing: '0.08em', textTransform: 'uppercase',
              margin: '0 0 10px 8px',
            }}>
              Folders
            </p>
          </div>
          <nav className="nav-menu">
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {menuItems.map((item) => (
                <li
                  key={item.eventKey}
                  style={{
                    margin: '2px 6px',
                    borderRadius: '8px',
                    backgroundColor: activeTab === item.eventKey ? '#EEF2FF' : 'transparent',
                    transition: 'background 0.15s',
                  }}
                >
                  <Link
                    onClick={() => setActiveTab(item.eventKey)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '8px 10px',
                      textDecoration: 'none',
                      color: activeTab === item.eventKey ? '#154889' : '#374151',
                      fontWeight: activeTab === item.eventKey ? 600 : 400,
                      fontSize: '0.85rem',
                    }}
                  >
                    <item.icon
                      size={16}
                      color={activeTab === item.eventKey ? '#154889' : '#6b7280'}
                    />
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </Col>

        {/* ── Right panel — tab content, files sorted by date ─────────────── */}
        <Col
          sm={10}
          style={{
            backgroundColor: '#F9FAFB',
            borderRadius: '0 10px 10px 0',
            overflowY: 'auto',
            maxHeight: '68vh',
            padding: '16px',
          }}
        >
          <Tab.Content>
            {menuItems.map((item) => (
              <Tab.Pane key={item.eventKey} eventKey={item.eventKey}>
                {/* Only mount TabContent for the active tab to avoid 
                    firing 6 simultaneous API calls on load */}
                {activeTab === item.eventKey && (
                  <TabContent
                    tabName={item.name}
                    clientId={leadId}
                    folder={item.eventKey}
                    availableSubFolders={item.availableSubFolders}
                  />
                )}
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  );
}

export default LeadDocuments;